/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  setElementHeights,
  WEB_API_ACCOUNT_NAV,
} from '../../assets/constants/strings';
import ApiHeader from '../../components/API/UIElements/Header';
import TitleBar from '../../components/API/UIElements/TitleBar';
import AccountLeftNav from '../../components/API/AccountSettings/AccountLeftNav';
import { useParams } from 'react-router-dom';
import './style.scoped.scss';
import Footer from '../../components/Footer';
import $ from 'jquery';
import UserInfo from '../../components/API/AccountSettings/UserInfo';
import PaymentSettingsAPI from '../../components/API/AccountSettings/Payments';
import DeactivateAccount from '../../components/API/AccountSettings/Deactivate';
import Users from '../../components/MyAccount/Users';
import { connect } from 'react-redux';
import { getUsersByClientId } from '../../store/User/userActions';
import { isCorporateAdmin } from '../../services/entitlements';

const ApiUserAccount = ({ user, usersByClient, getUsersByClientId }) => {
  const { page } = useParams();

  const [selectedPage, setSelectedPage] = useState(page);

  // The Team tab is CorporateAdmin-only — drop it from the nav for other users.
  const corpAdmin = isCorporateAdmin(user);
  const nav = { ...WEB_API_ACCOUNT_NAV };
  if (!corpAdmin) delete nav.TEAM;

  useEffect(() => {
    $(window).on('resize', setElementHeights);
  }, []);

  // Load the org's members for the Team tab (CorporateAdmin only).
  useEffect(() => {
    if (corpAdmin && user && user.clientId && !usersByClient) getUsersByClientId();
  }, [corpAdmin, user, usersByClient]);

  useEffect(() => {
    definePageTitle();
    setElementHeights();
  });

  const definePageTitle = () => {
    // need to ensure we can match to one of the pages
    let accountType = nav;
    if (
      page &&
      Object.values(accountType).filter((item) => item.URL === page).length > 0
    ) {
      setSelectedPage(page);
      document.title =
        Object.values(accountType).filter((item) => item.URL === page)[0].NAV +
        ' | RegulationCity';
    } else setSelectedPage(Object.values(accountType)[0].URL);
  };

  return (
    <div className='wf-doc-wrapper w-100' id='wf-doc-page'>
      <nav id='sticky-top-wrapper' className='navbar sticky-top p-0'>
        <div className='w-100 d-flex flex-column '>
          <ApiHeader hasNav />
          <TitleBar pageTitle='Account Settings' />
        </div>
      </nav>

      <main role='main' className='wf-document px-0 mb-0' id='wf-my-account'>
        <AccountLeftNav
          isUserAccount={true}
          navigationArray={nav}
          activePage={selectedPage}
        />

        <div className='col' id='main-content'>
          {{
            [WEB_API_ACCOUNT_NAV.INFO.URL]: <UserInfo />,
            [WEB_API_ACCOUNT_NAV.TEAM.URL]: corpAdmin ? <Users /> : null,
            [WEB_API_ACCOUNT_NAV.PAYMENT.URL]: <PaymentSettingsAPI />,
            [WEB_API_ACCOUNT_NAV.DEACTIVATE.URL]: <DeactivateAccount />,
          }[selectedPage] || (
            <h1>
              Welcome to your account settings. Please select an item on the
              left navigation to get started.
            </h1>
          )}
        </div>
      </main>
      <Footer isDocument isCentered isAbsolute />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  usersByClient: state.user.usersByClient,
});

export default connect(mapStateToProps, { getUsersByClientId })(ApiUserAccount);
